module.exports = __webpack_public_path__ + "img/V30.dabb8991.png";